import { OrderState } from '../../../core/enums/order-state.enum';

export class OrderStateDialogResult {
	public comment: string;
	public orderState: OrderState;
	public result: boolean;
}
